import React from 'react';

import CountryInfo from '../CountryInfo';

const RELIEF_SECTION = {
    title: 'HK Relief Package',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">
                HK$120 billion (US$15.4 billion) relief package will include:
            </p>
            <ul>
                <li>
                    $1200 (HK$10,000) cash subsidy to all adult permanent
                    residents
                </li>
                <li>
                    Relief measures for businesses: Low-interest loan with 100%
                    guarantee provided by the government, to a ceiling of HK$2
                    million, profits tax reduction of 100% on the first
                </li>
                <li>Salaries tax reduction of 100% on the first HK$20,000</li>
                <li>
                    Waiving rates on residential properties to a ceiling of
                    HK$1,500 per quarter
                </li>
                <li>
                    Paying one month&apos;s rent for people living in public
                    housing/lower income tenants
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Hong Kong unveils HK$10,000 handout as part of stimulus package',
            url: 'https://www.theedgemarkets.com/article/hong-kong-unveils-hk10000-handout-part-stimulus-package',
        },
    ],
};

const MORTGAGE_SECTION = {
    title: 'Hong Kong Mortgage Corporation Response',
    content: (
        <div>
            <p className="eds-text-bl eds-l-mar-bot-4">Options include:</p>
            <ul>
                <li>
                    Fixed-rate mortgage loans through the banks to provide
                    homebuyers with more options and reduce risk of interest
                    rate volatility.
                </li>
                <li>
                    Lowering the minimum eligible age for the HKMC Annuinity
                    plan to 60 to help people tap into their savings for
                    guaranteed income.
                </li>
                <li>
                    Special 100% loan guarantee under the medium-sixed
                    enterprises (SME) Financing Guarantee Scheme
                </li>
            </ul>
        </div>
    ),
    links: [
        {
            title: 'Hong Kong unveils HK$10,000 handout as part of stimulus package',
            url: 'http://www.hkmc.com.hk/eng/information_centre/press_releases.html#year=2020',
        },
    ],
};

const COUNTRY_INFO = {
    countryName: 'Hong Kong',
    lastUpdated: 'March 21, 2020',
    introSection: (
        <p>
            Hong Kong has multiple different financial assistance options
            available. Please look over this information and follow up as
            appropriate.
        </p>
    ),
    sections: [RELIEF_SECTION, MORTGAGE_SECTION],
};

const HongKongInfo = () => <CountryInfo info={COUNTRY_INFO} />;

export default HongKongInfo;
